import InquiryNoticeBox from '@/components/help/common/InquiryNoticeBox';

const ObjectionNotice = () => {
  return (
    <InquiryNoticeBox
      title='신청 전 확인해보세요!'
      list={[
        {
          text: '정지기간 중 이의신청은 1회만 가능하며 접수 진행 시 수정 및 삭제가 불가합니다.',
        },
      ]}></InquiryNoticeBox>
  );
};

export default ObjectionNotice;
